var sessionIdTemp = '';

export const getSessionIdTemp = () => sessionIdTemp;

export const setSessionIdTemp = sessionId => (sessionIdTemp = sessionId);
